import config from '../config/configureEnv';
import { ajax, getUserAuthDataFromLocalStorage } from '../utils';

export default {
  getLogs: () => {
    const userAuthData = getUserAuthDataFromLocalStorage();
    const { accessToken } = userAuthData;
    return ajax('GET', `${config.bocaAPIUrl}/activity-logs`, {
      urlParams: { access_token: accessToken },
    });
  },
  getLogsByFilter: (filter) => {
    const userAuthData = getUserAuthDataFromLocalStorage();
    const { accessToken } = userAuthData;
    return ajax('GET', `${config.bocaAPIUrl}/activity-logs`, {
      urlParams: {
        access_token: accessToken,
        filter,
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/ActivityLogAPIConnectors.js